export enum ServiceDetailEventTypes {
  UpdateToServiceForm,
  ResetToolbar,
  TogglePinDrop,
  UpdateUnderlyingService
}
